import axios from "../../services/axiosService";
import { Dispatch } from "redux";
import { ActionType } from "../action-types/index";
import { Action } from "../actions/AuthAction";
const URL = process.env.REACT_APP_API_URL;

export const adoptPet = (formData: any) => async (
  dispatch: Dispatch<Action>
) => {
  try {
    const response = await axios.post(`${URL}/api/v1/pet/pets-adopt`,formData);
    return response.data;
  } 
  catch (err) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

  
